package org.example.project.dashboard

import kotlinx.browser.window
import org.khronos.webgl.Uint8Array

internal fun decodedFocus2Html(): String {
    val binary = window.atob(FOCUS2_HTML_BASE64)
    val bytes = Uint8Array(binary.length)
    for (index in binary.indices) bytes.asDynamic()[index] = binary[index].code
    return js("new TextDecoder('utf-8')").decode(bytes) as String
}
